
































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import FilterLaporanKebidanan from "@/components/laporan-kebidanan/FilterLaporanKebidanan.vue";
import MatriksBulananKebidanan from "@/components/laporan-kebidanan/MatriksBulananKebidanan.vue";
import {
  BulanSimpanRekap,
  FilterKebidanan,
  KonflikRekap,
  LayananMatriksHibrida,
  MatriksHibridaResponse,
  NilaiRekap,
  OpsiUnitKebidanan,
  PasienRekap,
  filterAwal,
  filterSiap
} from "@/services/LaporanKebidanan";
import { hitungAkhir, hitungNilai } from "@/utils/rumusRekapBulanan";

const KONFIRMASI_BUANG =
  "Ada isian yang belum disimpan. Lanjutkan dan buang isian tersebut?";
const KONFIRMASI_CETAK =
  "Ada isian yang belum disimpan. Berkas dibuat dari data yang sudah tersimpan — lanjutkan tanpa isian tersebut?";
const NILAI_MAKS = 9999;

let tokenMuat = 0;

@Component({
  components: { FilterLaporanKebidanan, MatriksBulananKebidanan }
})
export default class LaporanMatriksHibrida extends Vue {
  @Prop({ type: String, required: true }) readonly judul!: string;
  @Prop({ type: Object, required: true })
  readonly layanan!: LayananMatriksHibrida;
  @Prop({ type: String, default: "Register Obstetri" })
  readonly sumberRincian!: string;
  @Prop({ type: String, default: "Ruang" }) readonly labelRuang!: string;
  @Prop({ type: Boolean, default: false }) readonly tanpaRuang!: boolean;

  filter: FilterKebidanan = { ...filterAwal(), mode: "tahunan", periode: String(new Date().getFullYear()) };
  filterTampil: FilterKebidanan | null = null;
  data: MatriksHibridaResponse | null = null;
  opsiUnit: OpsiUnitKebidanan[] = [];
  draft: Record<string, number> = {};
  awal: Record<string, number> = {};
  konflik: KonflikRekap[] | null = null;
  sukses = "";
  tab = 0;
  loading = false;
  menyimpan = false;
  mencetak = false;
  mengunduh = false;
  rincian: { buka: boolean; judul: string; pasien: PasienRekap[] } = {
    buka: false,
    judul: "",
    pasien: []
  };

  get bisaMengisi(): boolean {
    return (
      !!this.data &&
      this.data.boleh_ubah &&
      this.data.kolom.some(k => k.koreksi_berlaku)
    );
  }

  get bulanBerubah(): string[] {
    const bulan: Record<string, boolean> = {};
    const kunci = Object.keys(this.draft).concat(Object.keys(this.awal));

    kunci.forEach(k => {
      if (this.draft[k] !== this.awal[k]) bulan[k.split("|")[0]] = true;
    });

    return Object.keys(bulan).sort();
  }

  get jumlahBerubah(): number {
    const semua: Record<string, boolean> = {};

    Object.keys(this.draft)
      .concat(Object.keys(this.awal))
      .forEach(k => {
        if (this.draft[k] !== this.awal[k]) semua[k] = true;
      });

    return Object.keys(semua).length;
  }

  get nilaiTampil(): NilaiRekap {
    if (!this.data) return {};

    const d = this.data;
    const dasar: NilaiRekap = {};

    Object.keys(d.rme).forEach(kunci => {
      const baris: Record<string, number | null> = {};

      d.kolom.forEach(k => {
        const id = k.id + "|" + kunci;
        baris[k.id] =
          k.koreksi_berlaku && Object.prototype.hasOwnProperty.call(this.draft, id)
            ? this.draft[id]
            : d.rme[kunci][k.id];
      });

      dasar[kunci] = baris;
    });

    return hitungNilai(d.definisi, d.kolom, dasar);
  }

  get akhirTampil(): Record<string, Record<string, number | null>> {
    if (!this.data) return {};

    const d = this.data;
    const nilai = this.nilaiTampil;
    const hasil: Record<string, Record<string, number | null>> = {};

    d.lembar.forEach(l => {
      l.blok.forEach(b => {
        if (!b.label_akhir) return;

        const baris: Record<string, number | null> = {};

        b.baris.forEach(r => {
          baris[r.key] = hitungAkhir(d.definisi, d.kolom, nilai, r.key, b.akhir);
        });

        hasil[b.key] = baris;
      });
    });

    return hasil;
  }

  get dikoreksi(): Record<string, boolean> {
    const hasil: Record<string, boolean> = {};

    if (!this.data) return hasil;

    Object.keys(this.draft).forEach(id => {
      const [kolom, kunci] = id.split("|");
      const rme = this.data && this.data.rme[kunci] ? this.data.rme[kunci][kolom] : null;

      if (rme === null || rme === undefined || rme !== this.draft[id]) hasil[id] = true;
    });

    return hasil;
  }

  get asal(): Record<string, string> {
    const hasil: Record<string, string> = {};

    if (!this.data) return hasil;

    this.data.lembar.forEach(l => {
      l.blok.forEach(b => {
        b.baris.forEach(r => {
          if (r.ubah && !hasil[r.key]) {
            hasil[r.key] = `"${r.label || r.keterangan}" di sheet ${l.nama}`;
          }
        });
      });
    });

    return hasil;
  }

  mounted(): void {
    window.addEventListener("beforeunload", this.cegahTutup);
    this.muat();
  }

  beforeDestroy(): void {
    window.removeEventListener("beforeunload", this.cegahTutup);
  }

  cegahTutup(ev: BeforeUnloadEvent): void {
    if (this.jumlahBerubah > 0) {
      ev.preventDefault();
      ev.returnValue = "";
    }
  }

  bolehDitinggalkan(): boolean {
    return this.jumlahBerubah === 0 || window.confirm(KONFIRMASI_BUANG);
  }

  tampilkan(): void {
    if (!this.bolehDitinggalkan()) return;

    this.muat();
  }

  async muat(): Promise<void> {
    if (!filterSiap(this.filter)) return;

    const token = ++tokenMuat;
    const filter: FilterKebidanan = { ...this.filter, unit: this.filter.unit.slice() };
    this.loading = true;

    try {
      const res = await this.layanan.muat(filter);

      if (token !== tokenMuat) return;

      this.terapkan(res);
      this.filterTampil = filter;
      this.opsiUnit = res.params.opsi_unit;
      this.konflik = null;
      this.sukses = "";
    } catch {
      return;
    } finally {
      if (token === tokenMuat) this.loading = false;
    }
  }

  terapkan(res: MatriksHibridaResponse): void {
    const awal: Record<string, number> = {};

    res.kolom.forEach(k => {
      const peta = res.koreksi[k.id];

      if (!k.koreksi_berlaku || !peta) return;

      Object.keys(peta).forEach(kunci => {
        awal[k.id + "|" + kunci] = peta[kunci];
      });
    });

    this.data = res;
    this.awal = awal;
    this.draft = { ...awal };
  }

  ubah(e: { kolom: string; kunci: string; teks: string }): void {
    if (!this.data) return;

    const id = e.kolom + "|" + e.kunci;
    const bersih = String(e.teks || "").replace(/[^0-9]/g, "");

    if (bersih === "") {
      this.$delete(this.draft, id);
      return;
    }

    const angka = Math.min(parseInt(bersih, 10), NILAI_MAKS);
    const baris = this.data.rme[e.kunci];
    const rme = baris ? baris[e.kolom] : null;

    if (rme !== null && rme !== undefined && rme === angka) {
      this.$delete(this.draft, id);
    } else {
      this.$set(this.draft, id, angka);
    }
  }

  batalkan(): void {
    this.draft = { ...this.awal };
    this.konflik = null;
  }

  async simpan(): Promise<void> {
    if (!this.data || !this.jumlahBerubah) return;

    const data = this.data;
    const bulan: BulanSimpanRekap[] = this.bulanBerubah.map(p => {
      const koreksi: Record<string, number> = {};

      Object.keys(this.draft).forEach(id => {
        const [kolom, kunci] = id.split("|");
        if (kolom === p) koreksi[kunci] = this.draft[id];
      });

      return { periode: p, versi: data.versi[p] || 0, koreksi };
    });

    this.menyimpan = true;
    this.sukses = "";

    try {
      const res = await this.layanan.simpan(bulan);

      if (res.konflik) {
        this.konflik = res.konflik;
        return;
      }

      if (!res.hasil) return;

      res.hasil.bulan.forEach(b => {
        this.$set(data.versi, b.periode, b.versi);
        this.$set(data.koreksi, b.periode, { ...b.koreksi });

        Object.keys(b.rme).forEach(kunci => {
          if (data.rme[kunci]) this.$set(data.rme[kunci], b.periode, b.rme[kunci]);
        });

        Object.keys(this.awal)
          .filter(id => id.split("|")[0] === b.periode)
          .forEach(id => this.$delete(this.awal, id));
        Object.keys(this.draft)
          .filter(id => id.split("|")[0] === b.periode)
          .forEach(id => this.$delete(this.draft, id));
        Object.keys(b.koreksi).forEach(kunci => {
          this.$set(this.awal, b.periode + "|" + kunci, b.koreksi[kunci]);
          this.$set(this.draft, b.periode + "|" + kunci, b.koreksi[kunci]);
        });
      });

      this.konflik = null;
      this.sukses = res.hasil.message;
    } catch {
      return;
    } finally {
      this.menyimpan = false;
    }
  }

  muatUlangKonflik(): void {
    this.draft = { ...this.awal };
    this.muat();
  }

  bukaRincian(e: { kolom: string; kunci: string; label: string }): void {
    if (!this.data) return;

    const r = this.data.rincian[e.kunci];
    const indeks = r && r[e.kolom] ? r[e.kolom] : [];
    const d = this.data;
    const i = d.kolom.findIndex(k => k.id === e.kolom);
    let labelKolom = e.kolom;

    d.lembar.forEach(l => {
      l.blok.forEach(b => {
        if (b.baris.some(x => x.key === e.kunci) && i >= 0) {
          labelKolom = b.label_kolom[i];
        }
      });
    });

    this.rincian = {
      buka: true,
      judul: `${e.label} — ${labelKolom} (${indeks.length} pasien)`,
      pasien: indeks.map(x => d.pasien[x])
    };
  }

  konfirmasiBerkas(): boolean {
    return this.jumlahBerubah === 0 || window.confirm(KONFIRMASI_CETAK);
  }

  async cetakPdf(): Promise<void> {
    if (!this.filterTampil || !this.konfirmasiBerkas()) return;

    this.mencetak = true;

    try {
      await this.layanan.pdf(this.filterTampil);
    } catch {
      return;
    } finally {
      this.mencetak = false;
    }
  }

  async unduhExcel(): Promise<void> {
    if (!this.filterTampil || !this.konfirmasiBerkas()) return;

    this.mengunduh = true;

    try {
      await this.layanan.excel(this.filterTampil);
    } catch {
      return;
    } finally {
      this.mengunduh = false;
    }
  }
}
